import React, { Component } from 'react';
import axios from 'axios';
import './styles/Layout.css';
import ReactHtmlParser from 'react-html-parser';
import Spinner from './common/Spinner';

export class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            extHTML: ""
        };
    }
    componentDidMount() {
        this.loadSection();
    }
    loadSection() {
        let getSection = new Promise((resolve, reject) => {
            this.GetSection(resolve, reject);
        });
        getSection.then((data) => {
            if (data.length > 0) {
                this.setState({
                    extHTML: data
                });
            }
        });
    }
    GetSection(resolve, reject) {
        axios.get('/cdn/content/NobleWebsiteFooter.html').then(result => {
            resolve(result.data)
        }).catch((err) => {
            reject(err)
        })
    }
    render() {
        return (
            <div> {this.state.extHTML !== "" ? ReactHtmlParser(this.state.extHTML) : <Spinner />} </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js